import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Table from "../../../../common/components/Table/Table";
import {Button, Checkbox, Confirm, Popup} from "semantic-ui-react";
import {
    generatePDFReport,
    generateXLSReport,
} from "../../../../report-generation/veritas-report-gen/ReportGeneratorActions";
import KYBListRow from "./KYBListRow";
import {
    kybTableSearch,
    selectAllKYB,
    setKYBServicesFilter,
    toggleKYBSort,
    updateKYBFilters
} from "../../actions/ServicesActions";
import {SortFields} from "../../constants/ServiceActionConstants";
import {Filter} from "../../../../common/components/Filter";
import {TableSearch} from "../../../../common/components/TableSearch";

export class KYBServicesTable extends React.Component {

    state = {
        selectCountryWarning: false
    }

    static propTypes = {
        KYBServices: PropTypes.array,
    }

    handleSort = (sortKey) => {
        this.props.changeKYBSort(sortKey);
    }

    getIsServiceSelected = (serviceId) => {
        return this.props.selected_kyb_services.includes(serviceId);
    }

    handleCheckboxSelect = (e, {checked}) => {
        const serviceIds = this.props.filtered_kyb_services.map(service => {
            return service.service_id
        });
        this.props.selectAllKYB(serviceIds, checked);
    };

    handleKYBXLSReportClick = () => {
        const {selected_kyb_services, kybFilters} = this.props;
        const countryCodes = kybFilters.countryFilter.map(x => x.value);
        const countryCodesStr = countryCodes.join(',')
        const formattedIds = selected_kyb_services.join(',');
        if (countryCodesStr === "") {
            this.setState(prevState => ({
                selectCountryWarning: true
            }));
        } else {
            this.props.generateKYBXLSReport('external', formattedIds, countryCodesStr, "kyb");
        }
    };

    handleInternalKYBXLSReportClick = () => {
        const {selected_kyb_services, kybFilters} = this.props;
        const countryCodes = kybFilters.countryFilter.map(x => x.value);
        const countryCodesStr = countryCodes.join(',')
        const formattedIds = selected_kyb_services.join(',');
        if (countryCodesStr === "") {
            this.setState(prevState => ({
                selectCountryWarning: true
            }));
        } else {
            this.props.generateKYBXLSReport('internal', formattedIds, countryCodesStr, "kyb");
        }
    };

    handlePDFReportClick = () => {
        const {selected_kyb_services, kybFilters} = this.props;
        const countryCodes = kybFilters.countryFilter.map(x => x.value);
        const countryCodesStr = countryCodes.join(',')
        const formattedIds = selected_kyb_services.join(',');
        if (countryCodesStr === "") {
            this.setState(prevState => ({
                selectCountryWarning: true
            }));
        } else {
            this.props.generateKYBPDFReport(formattedIds, countryCodesStr, 'kyb');
        }
    };

    handleSelectCountryWarning = () => {
        this.setState(prevState => ({
            selectCountryWarning: false
        }));
    }

    handleKYBCountryFilter = (filterOption) => {
        this.props.setKYBServicesFilter(filterOption, "country");
        this.props.updateKYBFilter();
    }

    handleKYBTableSearch = (e) => {
        this.props.typeAheadSearchKYB(e.target.value)
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox
                    checked={this.props.all_kyb_selected}
                    onChange={this.handleCheckboxSelect}
                />
            </Table.Header>,
            <Table.Header key="approved"> </Table.Header>,
            <Table.Header key="name" sortKey={SortFields.SERVICE_NAME}>
                <span>Name</span>
            </Table.Header>,
            <Table.Header key="sub_dp">Sub DP Type</Table.Header>,
            <Table.Header key="country" className={"filterable-header"}>
                <div className={"header-text"} >Country</div>
                <Filter
                    isIcon={true}
                    isMulti={true}
                    placeholder="Country"
                    handleFilter={this.handleKYBCountryFilter}
                    options={this.props.kybFilterOptions.countryOptions}
                    value={this.props.kybFilters.countryFilter}
                />
            </Table.Header>,
            <Table.Header key="source-types">Source Type(s)</Table.Header>,
            <Table.Header key="status" sortKey={SortFields.STATUS}>Status</Table.Header>,
            <Table.Header key="updated" sortKey={SortFields.LAST_UPDATED}>Last Updated</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        return this.props.KYBServices.map(service => (
            <KYBListRow
                key={service.service_id}
                serviceID={service.service_id}
                serviceName={service.service_name}
                serviceConfigName={service.primary_service_config_name}
                dataProviderName={service.provider_name}
                isApproved={service.is_approved}
                associatedCountries={service.associated_countries}
                currency={service.currency}
                perUnitCost={service.cost}
                pricingModel={service.price_model}
                status={service.integration_status}
                subDPType={service.sub_type}
                sourceTypes={service.source_types_with_identifiers}
                isSelected={this.getIsServiceSelected(service.service_id)}
                lastUpdated={service.last_updated}
            />
        ));
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Popup
                        content={"Generate PDF Report"}
                        trigger={
                            <Button
                                disabled={!this.props.all_kyb_selected && !this.props.some_kyb_selected }
                                icon="file pdf outline" size="big"
                                onClick={this.handlePDFReportClick}
                            />
                        }
                    />
                    <Popup
                        content={"Generate Excel Report"}
                        trigger={
                            <Button
                                icon="file excel outline" size="big"
                                disabled={!this.props.all_kyb_selected && !this.props.some_kyb_selected}
                                onClick={this.handleKYBXLSReportClick}
                            />
                        }
                    />
                    {
                        this.props.isDPEditor ? (
                            <Popup
                                content={"Generate Internal-Only Source Report"}
                                trigger={
                                    <Button
                                        icon="file excel outline" size="big"
                                        disabled={!this.props.all_kyb_selected && !this.props.some_kyb_selected}
                                        onClick={this.handleInternalKYBXLSReportClick}
                                    />
                                }
                            />
                        ) : null
                    }
                </div>
                <div className="data-services-list-container">
                    <TableSearch
                        handleSearch={this.handleKYBTableSearch}
                    />
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table sortable"
                            currSortKey={this.props.kybSortKey}
                            sortDirection={this.props.kybSortDirection}
                            headers={this.tableHeaders}
                            onSort={this.handleSort}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Confirm
                    open={this.state.selectCountryWarning}
                    content={
                        "In order to generate any report, you have to select the countries in the filter. " +
                        "A report of the sources in those selected countries will be generated. " +
                        "If you want to generate a report of all the sources used by that service, " +
                        "please select `ALL` as the value in the country filter."
                    }
                    onConfirm={this.handleSelectCountryWarning}
                    onCancel={this.handleSelectCountryWarning}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_kyb_selected: state.veritas.kybServices.all_kyb_selected,
    selected_kyb_services:state.veritas.kybServices.selected_kyb_services,
    kyb_services: state.veritas.kybServices.kyb_services,
    filtered_kyb_services: state.veritas.kybServices.filtered_kyb_services,
    kybSortKey: state.veritas.kybServices.kybSortKey,
    kybSortDirection: state.veritas.kybServices.kybSortDirection,
    some_kyb_selected: state.veritas.kybServices.some_kyb_selected,
    kybFilterOptions: state.veritas.kybServices.kybFilterOptions,
    kybFilters: state.veritas.kybServices.kybFilters,
    isDPEditor: state.marvel.user.access.accessLevel.isDPEditor,
});

const mapDispatchToProps = dispatch => ({
    selectAllKYB: (serviceIds, isSelected) => {dispatch(selectAllKYB(serviceIds, isSelected))},
    generateKYBXLSReport: (reportType, selectedServices, countryCodes, serviceType) => {
        dispatch(generateXLSReport(reportType, selectedServices, countryCodes, serviceType))
    },
    generateKYBPDFReport: (selectedServices, countryCodes, serviceType) => {
        dispatch(generatePDFReport(selectedServices, countryCodes, serviceType))
    },
    changeKYBSort: (sortKey) => {dispatch(toggleKYBSort(sortKey))},
    setKYBServicesFilter: (filterOption, type) => {dispatch(setKYBServicesFilter(filterOption, type))},
    updateKYBFilter: () => {dispatch(updateKYBFilters())},

    typeAheadSearchKYB: (value) => {dispatch(kybTableSearch(value))}
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBServicesTable)
